module.exports = __webpack_public_path__ + "static/WelcomeToElk10-c5d81f88e8d3260dd825f1ec16c857bf.png";